module.exports = __webpack_public_path__ + "img/CRI.cef48071.svg";